import React from 'react';

import useTeamRefreshGuid from '../../../../hooks/useTeamRefreshGuid';
import { team_subscription_path } from '../../../../routes';
import { Team } from '../../../../utils/backend-api/teams';
import LinkCopy from '../../../Referral/LinkCopy';
import styles from './styles.module.css';

export default function SignupLink({ team }: { team: Team }) {
  const { refreshTeamGuid, isRefreshTeamGuidLoading } = useTeamRefreshGuid();

  const onClickRefresh = () => {
    if (confirm('Are you sure you want to refresh the signup link?') == true) {
      refreshTeamGuid();
    }
  };

  return (
    <div className="TextField">
      <label className="input-label" htmlFor="guid">
        Signup Link
      </label>
      <div className="label-description">
        Allow anyone with this link to sign up for The Information and be automatically added to my
        account.
      </div>
      <div className={styles.signupLinkContainer}>
        <LinkCopy referralUrl={`${window.location.origin}${team_subscription_path(team.guid)}`} />
      </div>
      <div>
        <button
          className={styles.linkRefresh}
          onClick={onClickRefresh}
          disabled={isRefreshTeamGuidLoading}
        >
          Refresh
        </button>
      </div>
    </div>
  );
}
